@if(signInResponse?.data?.applicantId == null ||
signInResponse?.data?.applicantId == undefined){
@if(showTempSuspendMessage){
<div class="w-100 rounded-5 py-3 mb-4 d-flex align-items-center px-2 warning"
    role="alert">
    <img class="mx-2 upload-icon flex-shrink-0" style="width: 35px;" src="assets/icons/warning-02-rounded.svg" alt="">
    {{translateService.currentLang === 'ar' ? '' : ''}}
    @if(translateService.currentLang === 'ar'){
    <p class="mb-0 text-3 p-2 mt-1 line-3">تم تعليق حسابك مؤقتًا
        لإعادة تفعيل حسابك، <span style="color: var(--form-element-input-color);" (click)="navigate('/contact-us')"
            class="c-pointer text-nowrap ibm-medium">إضغط هنا</span> لإرسال طلبك إلى فريق الدعم</p>
    }
    @else{
    <p class="mb-0 text-3 p-2 mt-1 line-3">Your Account has been temporarily suspended,
        To reactivate your Account, please <span style="color: var(--form-element-input-color);"
            (click)="navigate('/contact-us')" class="c-pointer ibm-medium">Click here</span> to send a
        request
        to Support Team</p>
    }
</div>
}
<div>
    <div class="form-floating">
        <input class="form-control px-4" id="civilId" type="number" autocomplete="off"
            placeholder="{{'CREATE_VISA.KUWAIT_RESIDENCE_INFO.CIVIL_ID_NO' | translate}}" appNumberOnly
            [max]="civilIdMaxLimit" [formControl]="civilIdControl" [pattern]="civilIDFormat" />
        <label>{{ "CREATE_VISA.KUWAIT_RESIDENCE_INFO.CIVIL_ID_NO" | translate }}</label>
        <app-validation-message [control]="civilIdControl"></app-validation-message>
    </div>
</div>
<button [disabled]="!civilIdControl.valid" type="button" (click)="onClickSignIn()"
    class="btn-1 w-100 p-2 my-4">
    {{ "SIGN_IN.LOGIN_BUTTON" | translate }}
</button>

}
<!-- captcha-->
@if(showCaptcha){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}
<p class="click-here text-2 ibm-medium text-center">
    {{ "SIGN_IN.DONT_HAVE_ACCOUNT" | translate }}
    <span class="c-pointer ibm-medium text-nowrap" (click)="navigate(routeType.FAMILY_SIGN_UP)">{{
        "SIGN_IN.CLICK_HERE_TO_SIGN_UP" | translate
        }}</span>
</p>